module.exports = __webpack_public_path__ + "img/DIRECTOR_REMOVED.626de0f3.svg";